import CardSideSelect from './CardSideSelect';

export default CardSideSelect;
